module.exports = __webpack_public_path__ + "static/media/011.b1738d6c.jpg";